/**
 * Comparison data structure for period-over-period analysis
 */
export interface ComparisonData {
  current: number
  previous: number
  difference: number
  percentageChange: number
  isPositive: boolean
}

/**
 * Calculate comparison metrics between current and previous period
 */
export function calculateComparison(
  currentValue: number,
  previousValue: number,
): ComparisonData {
  const difference = currentValue - previousValue

  // Calculate percentage change
  let percentageChange = 0
  if (previousValue !== 0) {
    percentageChange = ((currentValue - previousValue) / previousValue) * 100
  } else if (currentValue > 0) {
    // If previous was 0 but current is positive, show as 100% increase
    percentageChange = 100
  }

  return {
    current: currentValue,
    previous: previousValue,
    difference,
    percentageChange: Math.round(percentageChange * 10) / 10, // Round to 1 decimal
    isPositive: difference >= 0,
  }
}
